export default __webpack_public_path__ + "static/media/insta2.f54ad9fc.svg";